import React from 'react';
import { FeatureCell } from './FeatureCell';
import { LicensePlan, LicenseFeature } from '../../types/license';

interface FeatureGroupProps {
  groupName: string;
  features: LicenseFeature[];
  plans: LicensePlan[];
}

export const FeatureGroup: React.FC<FeatureGroupProps> = ({ 
  groupName, 
  features, 
  plans 
}) => {
  const isSpecialGroup = groupName === 'Copilot';
  
  return (
    <React.Fragment>
      <tr className={`${isSpecialGroup ? 'bg-blue-50' : 'bg-gray-50'}`}>
        <td 
          colSpan={plans.length + 1} 
          className={`px-6 py-3 text-left text-sm font-semibold ${
            isSpecialGroup ? 'text-blue-900' : 'text-gray-900'
          }`}
        >
          {groupName}
        </td>
      </tr>
      {features.map((feature) => (
        <tr key={feature.name} className={`hover:bg-gray-50 ${
          isSpecialGroup ? 'bg-blue-50/30' : ''
        }`}>
          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
            {feature.name}
          </td>
          {plans.map((plan) => (
            <td 
              key={`${plan.id}-${feature.name}`}
              className="px-6 py-4 whitespace-nowrap text-sm text-center"
            >
              <FeatureCell 
                feature={Array.isArray(plan.features) 
                  ? plan.features.find(f => f.name === feature.name)
                  : undefined
                } 
              />
            </td>
          ))}
        </tr>
      ))}
    </React.Fragment>
  );
};